import { ApiService } from 'services';

const URL_ACCOUNT = '/accounts';

async function getAccount() {
  return await ApiService.callApiAuthenticated({
    method: 'GET',
    path: `${URL_ACCOUNT}/me`,
  });
}

async function createAccount(ssoID) {
  return await ApiService.callApiAuthenticated({
    method: 'POST',
    path: URL_ACCOUNT,
    body: {
      status: 'ACTIVE',
      ssoID,
    },
  });
}

export default {
  getAccount,
  createAccount,
};
